@if($canShowLauncher()){
    <div cdkOverlayOrigin #trigger="cdkOverlayOrigin" (mouseenter)="open = true" [ngClass]="{ active: active} " [attr.data-tour-target]="helpMenu.id">
        <a class="side-nav-item has-menu" [ngClass]="{'active':active}">
            <div class="icon-container">
                <i [class]="helpMenu.icon"></i>
                @if(hasBadge){
                    <span class="badge">
                    </span>
                }
            </div>
            <span class='title'>{{helpMenu.title}}</span>
        </a>

        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="open" [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayScrollStrategy]="overlay.scrollStrategies.close()" (attach)="onAttached()" (detach)="open = false" (overlayOutsideClick)="open = false">
            <!-- <div class="side-nav-item-menu" (mouseleave)="open = false"> -->
            <div class="side-nav-item-menu" (mouseleave)="open = false">
                <div class="fieldset">
                    @for (parent of helpMenu.children; track $index) {
                        <legend>
                            {{parent.title}}
                        </legend>
                        <!-- <div class="group-child"> -->
                        @for (childOfChild of parent.children; track $index; let index= $index) {
                            <div class="item-wrapper">
                                <a class="side-nav-item" (click)="childOfChild.action()" [attr.data-tour-target]="childOfChild.id">
                                    <div class="icon-container">
                                        <i [class]="childOfChild.icon" [ngClass]="{'icon-size': index != 0 && parent.hasLine}"></i>
                                        @if(childOfChild.badgeNumber){
                                            <span class="badge" [ngClass]="{'plus':childOfChild.badgeNumber > maxUnreadCount}">
                                                @if(childOfChild.showNumber){
                                                    {{childOfChild.badgeNumber <= maxUnreadCount ? childOfChild.badgeNumber : maxUnreadCount+'+'}}
                                                }
                                            </span>
                                        }
                                    </div>
                                    <span>{{childOfChild?.title}}</span>
                                    @if(childOfChild.isLink){
                                        <i class="link-icon fa-solid fa-arrow-up-right"></i>
                                    }
                                </a>
                                @if(parent.hasLine && index!=0){
                                    <span class="line" [ngStyle]="{'bottom.px':21, 'height.px': index === 1 ? 32 : 34 }">
                                    </span>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </ng-template>

        <div cdkOverlayContainer></div>
    </div>
}